import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";

export const transcriptionRouteInputSchema = z.strictObject({
  roomId: z.string().min(1).max(255).optional(),
});
export const transcriptionRouteSchema = z
  .object({
    reservationId: z.uuid(),
    generation: z.uuid(),
    slot: z.enum(["a", "b"]),
    path: z.enum(["/socket/a/", "/socket/b/"]),
    expiresAt: z.iso.datetime(),
  })
  .refine((route) => route.path === `/socket/${route.slot}/`);
export const transcriptionRouteContract = {
  reserveTranscriptionRoute: oc
    .errors({
      BAD_REQUEST: {},
      UNAUTHORIZED: {},
      FORBIDDEN: {},
      NOT_FOUND: {},
      SERVICE_UNAVAILABLE: {},
      METHOD_NOT_ALLOWED: {},
      INTERNAL_SERVER_ERROR: {},
    })
    .input(z.object({ body: transcriptionRouteInputSchema }))
    .meta(
      openapi({
        method: "POST",
        path: "/api/v2/transcription-routes",
        inputStructure: "detailed",
        successStatus: 201,
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(transcriptionRouteSchema),
};
